import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React from 'react';

import SavedSearchesTable from './SavedSearchesTable';
import NavigateLinkCell from '../containers/FindPage/NavigateLinkCell';
import { useTranslation } from '../custom-hooks/useTranslation';

const useStyles = makeStyles({
  modal: {
    minWidth: '80%',
    zIndex: 1200,
  },
});

export const RunSavedSearchDialog = ({
  runSavedSearchConfig,
  isRunModalOpen,
  setIsRuntModalOpen,
}) => {
  const translateString = useTranslation();
  const classes = useStyles();

  return (
    <Modal
      open={isRunModalOpen}
      variant="default"
      onClose={() => setIsRuntModalOpen(false)}
      title={runSavedSearchConfig.savedSearchName}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
      hideButtons
    >
      <SavedSearchesTable
        entityName={runSavedSearchConfig.entityName}
        initialSearchName={runSavedSearchConfig.savedSearchName}
        title={translateString('Records')}
        rowsPerPageOptions={[10, 25, 50]}
        customCell={NavigateLinkCell.savedSearchColumnLink}
        showSearchSelector={false}
        enableSorting
      />
    </Modal>
  );
};

export default RunSavedSearchDialog;
